/**
 * Interface with the server
 */
import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

const onDemandAPI = API('/api/onDemandCourses.v1/', { type: 'rest' });

const getResourceURL = (courseSlug: $TSFixMe) => {
  return new URI().addQueryParam('q', 'slug').addQueryParam('slug', courseSlug).toString();
};

const CourseAPIUtils = {
  load(courseSlug: $TSFixMe) {
    return Q(onDemandAPI.get(getResourceURL(courseSlug)));
  },

  loadById(courseId: $TSFixMe) {
    return Q(onDemandAPI.get(courseId));
  },
};

export default CourseAPIUtils;

export const { load, loadById } = CourseAPIUtils;
